export const SmsCommands = {
  GET_QUOTES: 'GET QUOTES',
  MUTE_QUOTES: 'MUTE QUOTES',
} as const;

export const SmsCommandIntent = {
  OPT_IN: 'OPT_IN',
  OPT_OUT: 'OPT_OUT',
} as const;
